export enum HTMLData_Source {
  HTML = 'HTML',
  ADSENSE = 'ADSENSE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}